module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-23d4c812dbe155d1f2456b5825d0cb15.png";